import { useTranslation } from 'react-i18next';

/*
 * Manual language toggle in the topbar. The picked language is cached
 * by the i18next language detector (localStorage), so it survives
 * reloads and overrules the browser language.
 *
 * On wide screens every language gets its own button; on phones a
 * single cycle button is shown instead (CSS swaps them) that advances
 * to the next language with every tap, saving scarce topbar space.
 */
const languages = [
  { code: 'de', label: 'DE', name: 'Deutsch' },
  { code: 'en', label: 'EN', name: 'English' },
  { code: 'fr', label: 'FR', name: 'Français' },
];

export function LanguageSwitcher() {
  const { i18n } = useTranslation();

  const currentIndex = Math.max(
    languages.findIndex(({ code }) => code === i18n.resolvedLanguage),
    0
  );
  const current = languages[currentIndex];
  const next = languages[(currentIndex + 1) % languages.length];

  return (
    <span className="language-switcher">
      {languages.map(({ code, label, name }) => (
        <button
          key={code}
          className="language-choice"
          lang={code}
          title={name}
          aria-label={name}
          aria-pressed={i18n.resolvedLanguage === code}
          onClick={() => i18n.changeLanguage(code)}
        >
          {label}
        </button>
      ))}
      <button
        className="language-cycle"
        lang={current.code}
        title={next.name}
        aria-label={next.name}
        onClick={() => i18n.changeLanguage(next.code)}
      >
        {current.label}
      </button>
    </span>
  );
}
